import { ApplianceItem } from "./appliance-item";
import { Installation } from "./installation";
import { PaymentPlan } from "./paymentPlan";

export class SolarRecommendationForm {
    appliances: ApplianceItem[] = [];
    paymentPlan?: PaymentPlan;
    installation?: Installation;

    constructor({ appliances, paymentPlan, installation }: SolarRecommendationForm) {
        this.appliances = appliances ?? [];
        this.paymentPlan = paymentPlan;
        this.installation = installation;
    }
}